import React from "react";
import PropTypes from "prop-types";
import ReportsDesktop from "./ReportsDesktopDesktop";

function Reports({ app, config }) {
  return <ReportsDesktop app={app} config={config} />;
}

Reports.defaultProps = {
  app: null,
  config: {},
};

Reports.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Reports;
